

<!-- [disabled]=isDownloadDisabled('filename')  -->

 <div>

    <table class="dataEntryStatusTbl table filelisttable">
      <thead>
        <tr>
          <th>FROM</th>
          <th>TO</th>
          <th>DATE/TIME</th>
          <th>STATUS</th>
          <th>ACTION</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
          <tr class="filelisttable" *ngFor="let file of facilityExportRequestedFiles | paginate: config">
              <td>{{file.startYearQuarter}}</td>
              <td>{{file.endYearQuarter}}</td>
              <td>{{file.requestDate}}</td>
              <td class="td-status" [ngClass]="getStatusCss(file.status)"><span
                      class="status circle"></span><span>{{file.status}}</span></td>
              <td class="td-status" [ngClass]="getActionCss(file.status)">
                <span class="status circle "></span>
                <a class="cursor-pointer data-description filelisttable" (click)="downloadFile(file.fileID)">Download</a>
              </td>
          </tr>
      </tbody>
  </table>
  
    <div class="text-right">
        <pagination-controls #pagination [id]="config.id" [maxSize]="maxSize" [directionLinks]="directionLinks"
            [autoHide]="autoHide" [responsive]="responsive" [previousLabel]="labels.previousLabel"
            [nextLabel]="labels.nextLabel" [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
            [screenReaderPageLabel]="labels.screenReaderPageLabel"
            [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel" (pageChange)="onPageChange($event)"
            (pageBoundsCorrection)="onPageBoundsCorrection($event)" class="npgo-pagination">
        </pagination-controls>
    </div>
  
  
  </div> 